import { 
  FaTools, 
  FaCamera, 
  FaBirthdayCake, 
  FaTshirt, 
  FaHome, 
  FaDice, 
  FaSkiing, 
  FaGuitar,
  FaGamepad,
  FaMixer
} from 'react-icons/fa';


const categoriesList = [
  {
    id: 1,
    name: 'Alətlər', 
    Icon: FaTools
  },
  {
    id: 2,
    name: 'Elektronika', 
    Icon: FaCamera
  },
  {
    id: 3,
    name: 'Nişan & Toy', 
    Icon: FaBirthdayCake
  },
  {
    id: 4,
    name: 'Geyim', 
    Icon: FaTshirt
  },
  {
    id: 5,
    name: 'Ev & Mətbəx', 
    Icon: FaHome
  },
  {
    id: 6,
    name: 'Oyuncaqlar & Oyunlar', 
    Icon: FaDice
  },
  {
    id: 7,
    name: 'İdman malları', 
    Icon: FaSkiing
  },
  {
    id: 8,
    name: 'Musiqi', 
    Icon: FaGuitar
  },
  {
    id: 9,
    name: 'DVDS & Video oyunlar', 
    Icon: FaGamepad
  },
  {
    id: 10,
    name: 'Qarışıq', 
    Icon: FaMixer},
];

export default categoriesList;
